import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getErrorByName } from '../../../../../../../../../../Helper';
import { AutocompleteComponent } from '../../../../../../../../../../Components';
import { lookupItemsGetId } from '../../../../../../../../../../Services';
import { UspLookupTypeIdEnum } from '../../../../../../../../../../Enums';

export const UspAutocomplete = ({
  schema,
  onStateChanged,
  isSubmitted,
  parentTranslationPath,
  translationPath,
  selected,
  setSelected,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [usps, setUsps] = useState([]);
  const getAllUsp = useCallback(async () => {
    setIsLoading(true);
    const res = await lookupItemsGetId({
      lookupTypeId: UspLookupTypeIdEnum.lookupTypeId,
    });
    if (!(res && res.status && res.status !== 200)) setUsps(res || []);
    else setUsps([]);
    setIsLoading(false);
  }, []);
  const onAutocompleteChanged = (_, newValue) => {
    const ids = newValue.map((item) => item.uspId ?? item.lookupItemId);

    onStateChanged({
      id: 'uspIds',
      value: ids,
    });
    setSelected({
      id: 'usps',
      value: newValue,
    });
  };
  useEffect(() => {
    getAllUsp();
  }, [getAllUsp]);

  return (
    <div className='form-item'>
      <AutocompleteComponent
        idRef='uspIdRef'
        labelValue='usp'
        selectedValues={selected.usps}
        data={usps}
        displayLabel={(option) => option?.lookupItemName || ''}
        getOptionSelected={(option, value) =>
          option?.lookupItemId === (value?.uspId ?? value?.lookupItemId)
        }
        chipsLabel={(option) => option?.lookupItemName ?? option?.usp ?? ''}
        withoutSearchButton
        helperText={getErrorByName(schema, 'uspId').message}
        error={getErrorByName(schema, 'uspId').error}
        isWithError
        isLoading={isLoading}
        isSubmitted={isSubmitted}
        parentTranslationPath={parentTranslationPath}
        translationPath={translationPath}
        onChange={onAutocompleteChanged}
      />
    </div>
  );
};

UspAutocomplete.propTypes = {
  state: PropTypes.instanceOf(Object).isRequired,
  schema: PropTypes.instanceOf(Object).isRequired,
  onStateChanged: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
  parentTranslationPath: PropTypes.string.isRequired,
  translationPath: PropTypes.string.isRequired,
};
